/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import receiveImages from './receive-images';

export default (query = { page : 1, limit : 20 }) => (dispatch) => {
    //dispatch({
    //    type: actions.RESOURCES_REQUEST,
    //});

    return cecSdk
        .images()
        .list(query)
        .then((images) => {
            //dispatch({
            //    type: actions.RESOURCES_REQUEST_SUCCESS,
            //});
            dispatch(receiveImages(images));

            return images;
        });
};